export const toggleFilters = () => (
  { type: 'TOGGLE_FILTERS' }
);
